import { getSelectedVersion } from "../../store/versions";
import { INIT_REGULATION } from "./types";

const reset = () => async (dispatch, getState) => {
    const version = getSelectedVersion(getState());
    if (!version) {
        return;
    }
    dispatch({
        type: INIT_REGULATION,
        actionTendencies: version['action_tendency_regulations'],
        arousalLowScore: version['arousal_low_score'],
        arousalMediumScore: version['arousal_medium_score'],
        arousalHighScore: version['arousal_high_score'],
        emotionArousalScores: version['emotion_arousal_scores'] || [],
        emotionAttenuations: version['emotion_attenuations'] || [],
    });
};

export default reset;
